$(document).on('ready', function(){

    let flickity = Flickity.data( '.carousel-main' );
    $('.controls__control').on('click', function(){
        let self = $(this);
        let id = self.attr('id');
        id = id.replace('control__', '');
        let activeControl = $('.controls__control.active');
        activeControl.removeClass('active');
        self.addClass('active');
        flickity.select(id, false, true);
    })
    let action = $('#product-action-wrapper');
    let top = action.offset()?.top;
    let startingPosition = action[0]?.getBoundingClientRect().top;


    $(window).on('scroll', function(){
        let self = $(this);

        if (self.width() <= 992) {
            //fix button in place on mobile scroll for product page actions
            let viewportTop = self.scrollTop();
            let viewportHeight = self.height();
            let viewportBottom = viewportTop + viewportHeight;

            let height = action.height();
            let bottom = top + height;

            if ((top >= viewportTop && top < viewportBottom) ||
            (bottom > viewportTop && bottom <= viewportBottom) ||
            (height > viewportHeight && top <= viewportTop && bottom >= viewportBottom)) {
                action.addClass('active');
            }
        }
    })

});